import React from "react";

const ExclaimRed = () => {
  return (
    <svg
      width="120"
      height="120"
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="120" height="120" rx="12" fill="#FEF3F2" />
      <path
        d="M59.9998 45.8V61.8M64.9842 25.8352L69.868 29.9972C71.0985 31.0457 72.6262 31.6796 74.2377 31.8082L80.6338 32.318C84.3944 32.6181 87.3814 35.6032 87.6815 39.3637L88.19 45.7609C88.3186 47.3724 88.9548 48.9024 90.0033 50.1328L94.1635 55.0153C96.6104 57.8866 96.6108 62.1101 94.1639 64.9814L90.0037 69.8647C88.9552 71.0951 88.3198 72.6256 88.1912 74.2371L87.6795 80.6333C87.3794 84.3938 84.3971 87.3808 80.6365 87.6809L74.2381 88.1914C72.6266 88.32 71.0974 88.9523 69.867 90.0008L64.9842 94.1629C62.1129 96.6098 57.8867 96.6103 55.0154 94.1634L50.1326 90.0012C48.9022 88.9526 47.373 88.3192 45.7615 88.1906L39.3631 87.6809C35.6026 87.3808 32.6202 84.3945 32.3201 80.634L31.8084 74.2375C31.6798 72.626 31.0445 71.0968 29.9959 69.8664L25.8357 64.9817C23.3888 62.1104 23.3877 57.8881 25.8346 55.0168L29.9985 50.132C31.0471 48.9016 31.6763 47.3724 31.8049 45.761L32.3166 39.3645C32.6167 35.6039 35.6077 32.6177 39.3682 32.3176L45.7596 31.8078C47.371 31.6792 48.901 31.0458 50.1314 29.9973L55.0158 25.8352C57.8871 23.3883 62.1129 23.3883 64.9842 25.8352ZM60.199 73.8V74.2L59.8006 74.1985V73.8H60.199Z"
        stroke="#B42318"
        stroke-width="8"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default ExclaimRed;
